export default function () {
    const scrollTopFromTop = +document.body.style.top
        .slice(1)
        .substring(0, document.body.style.top.slice(1).length - 2)
    document.body.classList.remove('no-scroll')
    document.documentElement.scrollTop = scrollTopFromTop
}
